import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomerSupportRepository } from '@/core/domain/customer-support/repositories/customer-support.repository';
import { CustomerSupportImplRepository } from './customer-support-imp.respository';
import { SendFormUseCase } from '@/core/domain/customer-support/usecases/sendForm.usecase';
import { GetContactFormInformationUseCase } from '@/core/domain/customer-support/usecases/getContactFormInformation.usecase';

const sendFormUseCaseFactory = (repository: CustomerSupportRepository) =>
    new SendFormUseCase(repository);

const getContactFormInformationUseCaseFactory = (
    repository: CustomerSupportRepository,
) => new GetContactFormInformationUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetContactFormInformationUseCase,
            useFactory: getContactFormInformationUseCaseFactory,
            deps: [CustomerSupportImplRepository],
        },
        {
            provide: SendFormUseCase,
            useFactory: sendFormUseCaseFactory,
            deps: [CustomerSupportImplRepository],
        },
        {
            provide: CustomerSupportRepository,
            useClass: CustomerSupportImplRepository,
        },
    ],
})
export class CustomerSupportModule {}
